module.exports = __webpack_public_path__ + "img/loginbg1.9b0cf8d7.png";